/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.1
 * source: testsystem/v1/observer/observer.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../events/events";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
export namespace testsystem.v1.observer {
    export class AckResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[3]];
        constructor(data?: any[] | ({
            success?: boolean;
            message?: string;
        } & (({
            error_code?: number;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("success" in data && data.success != undefined) {
                    this.success = data.success;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
                if ("error_code" in data && data.error_code != undefined) {
                    this.error_code = data.error_code;
                }
            }
        }
        get success() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set success(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get error_code() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set error_code(value: number) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[0], value);
        }
        get has_error_code() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get _error_code() {
            const cases: {
                [index: number]: "none" | "error_code";
            } = {
                0: "none",
                3: "error_code"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            success?: boolean;
            message?: string;
            error_code?: number;
        }): AckResponse {
            const message = new AckResponse({});
            if (data.success != null) {
                message.success = data.success;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            if (data.error_code != null) {
                message.error_code = data.error_code;
            }
            return message;
        }
        toObject() {
            const data: {
                success?: boolean;
                message?: string;
                error_code?: number;
            } = {};
            if (this.success != null) {
                data.success = this.success;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            if (this.error_code != null) {
                data.error_code = this.error_code;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.success != false)
                writer.writeBool(1, this.success);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (this.has_error_code)
                writer.writeInt32(3, this.error_code);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AckResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AckResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.success = reader.readBool();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    case 3:
                        message.error_code = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): AckResponse {
            return AckResponse.deserialize(bytes);
        }
    }
    interface GrpcUnaryServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, metadata: grpc_1.Metadata, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
    }
    interface GrpcStreamServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): grpc_1.ClientReadableStream<R>;
        (message: P, options?: grpc_1.CallOptions): grpc_1.ClientReadableStream<R>;
    }
    interface GrpWritableServiceInterface<P, R> {
        (metadata: grpc_1.Metadata, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (metadata: grpc_1.Metadata, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
    }
    interface GrpcChunkServiceInterface<P, R> {
        (metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): grpc_1.ClientDuplexStream<P, R>;
        (options?: grpc_1.CallOptions): grpc_1.ClientDuplexStream<P, R>;
    }
    interface GrpcPromiseServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): Promise<R>;
        (message: P, options?: grpc_1.CallOptions): Promise<R>;
    }
    export abstract class UnimplementedTestEventCollectorService {
        static definition = {
            ReportRunStart: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportRunStart",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.ReportRunStartEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.ReportRunStartEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportSuiteBegin: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportSuiteBegin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.SuiteBeginEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.SuiteBeginEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportSuiteEnd: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportSuiteEnd",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.SuiteEndEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.SuiteEndEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportTestBegin: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportTestBegin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.TestBeginEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.TestBeginEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportTestEnd: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportTestEnd",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.TestEndEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.TestEndEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportStepBegin: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportStepBegin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.StepBeginEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.StepBeginEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportStepEnd: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportStepEnd",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.StepEndEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.StepEndEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportTestFailure: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportTestFailure",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.TestFailureEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.TestFailureEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportTestError: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportTestError",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.TestErrorEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.TestErrorEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportStdError: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportStdError",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.StdErrorEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.StdErrorEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportStdOutput: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportStdOutput",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.StdOutputEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.StdOutputEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            ReportRunEnd: {
                path: "/testsystem.v1.observer.TestEventCollector/ReportRunEnd",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.TestRunEndEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.TestRunEndEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            },
            Heartbeat: {
                path: "/testsystem.v1.observer.TestEventCollector/Heartbeat",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: dependency_1.testsystem.v1.events.HeartbeatEventRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => dependency_1.testsystem.v1.events.HeartbeatEventRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AckResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AckResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract ReportRunStart(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.ReportRunStartEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportSuiteBegin(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.SuiteBeginEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportSuiteEnd(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.SuiteEndEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportTestBegin(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.TestBeginEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportTestEnd(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.TestEndEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportStepBegin(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.StepBeginEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportStepEnd(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.StepEndEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportTestFailure(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.TestFailureEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportTestError(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.TestErrorEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportStdError(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.StdErrorEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportStdOutput(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.StdOutputEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract ReportRunEnd(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.TestRunEndEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
        abstract Heartbeat(call: grpc_1.ServerUnaryCall<dependency_1.testsystem.v1.events.HeartbeatEventRequest, AckResponse>, callback: grpc_1.sendUnaryData<AckResponse>): void;
    }
    export class TestEventCollectorClient extends grpc_1.makeGenericClientConstructor(UnimplementedTestEventCollectorService.definition, "TestEventCollector", {}) {
        constructor(address: string, credentials: grpc_1.ChannelCredentials, options?: Partial<grpc_1.ChannelOptions>) {
            super(address, credentials, options);
        }
        ReportRunStart: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.ReportRunStartEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.ReportRunStartEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportRunStart(message, metadata, options, callback);
        };
        ReportSuiteBegin: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.SuiteBeginEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.SuiteBeginEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportSuiteBegin(message, metadata, options, callback);
        };
        ReportSuiteEnd: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.SuiteEndEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.SuiteEndEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportSuiteEnd(message, metadata, options, callback);
        };
        ReportTestBegin: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.TestBeginEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.TestBeginEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportTestBegin(message, metadata, options, callback);
        };
        ReportTestEnd: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.TestEndEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.TestEndEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportTestEnd(message, metadata, options, callback);
        };
        ReportStepBegin: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.StepBeginEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.StepBeginEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportStepBegin(message, metadata, options, callback);
        };
        ReportStepEnd: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.StepEndEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.StepEndEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportStepEnd(message, metadata, options, callback);
        };
        ReportTestFailure: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.TestFailureEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.TestFailureEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportTestFailure(message, metadata, options, callback);
        };
        ReportTestError: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.TestErrorEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.TestErrorEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportTestError(message, metadata, options, callback);
        };
        ReportStdError: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.StdErrorEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.StdErrorEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportStdError(message, metadata, options, callback);
        };
        ReportStdOutput: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.StdOutputEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.StdOutputEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportStdOutput(message, metadata, options, callback);
        };
        ReportRunEnd: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.TestRunEndEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.TestRunEndEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.ReportRunEnd(message, metadata, options, callback);
        };
        Heartbeat: GrpcUnaryServiceInterface<dependency_1.testsystem.v1.events.HeartbeatEventRequest, AckResponse> = (message: dependency_1.testsystem.v1.events.HeartbeatEventRequest, metadata: grpc_1.Metadata | grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, options?: grpc_1.CallOptions | grpc_1.requestCallback<AckResponse>, callback?: grpc_1.requestCallback<AckResponse>): grpc_1.ClientUnaryCall => {
            return super.Heartbeat(message, metadata, options, callback);
        };
    }
}
